var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign_Out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4999 12.75L22.4999 22.5L1.49996 22.5L1.49996 12.75C1.49996 12.336 1.16393 12 0.749979 12C0.336025 12 1.39091e-07 12.3361 1.34155e-07 12.75L8.9434e-09 23.25C4.00706e-09 23.664 0.335963 24 0.749978 24L23.2499 24C23.6639 24 23.9999 23.664 23.9999 23.25L23.9999 12.7501C23.9999 12.3361 23.6638 12.0001 23.2499 12.0001C22.8359 12 22.4999 12.3361 22.4999 12.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5474 18.5301L17.7966 13.3552C18.0929 13.0619 18.0921 12.5872 17.7966 12.2947C17.5011 12.0014 17.0212 12.0014 16.7257 12.2947L12.7694 16.1947L12.7694 0.749978C12.7694 0.335963 12.4304 -2.44266e-07 12.0119 -2.62559e-07C11.5934 -2.80853e-07 11.2544 0.336025 11.2544 0.749978L11.2544 16.1947L7.29813 12.2947C7.00188 12.0014 6.52266 12.0014 6.22715 12.2947C5.9309 12.5879 5.9309 13.0627 6.22715 13.3552L11.4764 18.5294C11.7681 18.8189 12.2564 18.8219 12.5474 18.5301Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.feba05fae8329467d91e5c43b7ff154b.svg";
export { ForwardRef as ReactComponent };